<script>
export let label
export let value
</script>

<div class="flex flex-col">
    <div class="text-2xs font-medium text-gray-400 uppercase mb-1">{label}</div>
    <div class="text-3xl text-gray-800 font-regular mb-3">{value}</div>
</div>